import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import { AppStoreRankingsPageCompact } from "./AppStoreRankingsPageCompact";
import { AppStoreRankingsPageDefault } from "./AppStoreRankingsPageDefault";

export function AppStoreRankingsPage() {
  const isCompactView = useIsCompactView();
  return isCompactView ? <AppStoreRankingsPageCompact /> : <AppStoreRankingsPageDefault />;
}
